import React from "react";

const Contact = () => {
  return (
    <div className="contact blur-bg">
      <h4>Social media</h4>
      <div>
        <a href="https://www.linkedin.com/in/timurgolovinov/">linkedin</a>
        <a href="https://www.youtube.com/channel/UCmggIZkAvAIyuQX40ZQ2c8w">
          youtube
        </a>
        <a href="https://github.com/TimurGolovinov">github</a>
        {/* <a href="https://twitter.com/TGolovinov">twitter</a> */}
        {/* <a href="https://www.facebook.com/profile.php?id=100013373387382">
          facebook
        </a> */}
        <a href="https://www.instagram.com/timurrussia/">instagram</a>
        {/* <a href="https://vk.com/timurbg">vk</a> */}
        <a href="mailto:timurvalo@gmail.com">timurvalo@gmail.com</a>
      </div>
    </div>
  );
};

export default Contact;
